import Vue from 'vue';
import VueI18n from 'vue-i18n';
import messages from '@/lang/pt';

Vue.use( VueI18n );

// iniciação das traduções
const i18n = new VueI18n({
    locale: 'pt',
    messages: { ...messages }
});

export default i18n;